
import { Vue, Component } from 'vue-property-decorator';
import { Toast, Field, Button, RadioGroup, Radio } from 'vant';
import UploadTo from '@/components/next/Uploader.vue';
import { isWeiXin } from '@/common/ts/common';
import { getOssSignature, getDetail, updated, saveData } from '../api';
import { checkForm } from '../utils/check';

Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteLeave',
  'beforeRouteUpdate', // for vue-router 2.2+
]);

Vue.use(Toast)
  .use(Field)
  .use(Button)
  .use(Radio)
  .use(RadioGroup);
@Component({
  name: 'UploadPage',
  components: {
    UploadTo,
  },
})
export default class Upload extends Vue {
  imgPath = process.env.VUE_APP_OSS_IMG_DIR;
  videoPath = process.env.VUE_APP_OSS_VIDEO_DIR;
  detailData: any = {};

  // 审核状态
  isVerify: boolean = false;
  // 已上传的图片
  presetImg = [];
  // 已上传的视频
  presetVideo = [];
  // 需要的提交的图片
  needSubmitImg: any[] = [];
  video: any[] = [];
  // 作品名称
  name: string = '';
  // 作品简介
  intro: string = '';
  // 作品材料
  materials: string = '';
  // 作品尺寸
  size: string = '';
  // 是否愿意出售
  radio: any = '1';
  // 价格
  price: string | number = '';

  // 当前审核状态
  get status() {
    if (this.detailData.if_upload === 0) {
      return 2;
    } else {
      return 3;
    }
  }
  get fn() {
    return getOssSignature;
  }
  // 已保存的数据
  get tempData() {
    const data: any = {
      id: this.detailData.id,
      pictures:
        (this.detailData.pictures.length &&
          '|' + this.detailData.pictures.join('|')) ||
        '',
      videos:
        (this.detailData.videos.length &&
          '|' + this.detailData.videos.join('|')) ||
        '',
      title: this.detailData.title,
      introduction: this.detailData.introduction,
      material: this.detailData.material,
      workSize: this.detailData.workSize,
      ifSell: this.detailData.ifSell,
      price: this.detailData.price,
    };
    return data;
  }
  created() {
    console.log('page load!');
    this.getInitInfo();
  }
  public beforeRouteLeave(to: any, from: any, next: any) {
    this.$router.go(0);
  }
  // 获取初始信息
  async getInitInfo() {
    // console.log(11111, sessionStorage.getItem('syUserInfo') || '');
    const userinfo = sessionStorage.getItem('syUserInfo') || '';
    if (userinfo) {
      const id = window.sessionStorage.getItem('id' || '');
      const info = JSON.parse(sessionStorage.getItem('syUserInfo') || '');
      const res: any = await getDetail(info.chinaId, id);
      try {
        if (res.code === 200) {
          this.detailData = res.data;
          // 填充已有数据
          this.__presetData();
          if (Number(this.detailData.if_upload) === 1) {
            // // 填充已有数据
            // this.__presetData();
            if (this.detailData.enable === 1 || this.detailData.enable === 0) {
              this.isVerify = true;
            }
          }
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      Toast('当前状态未登录');
    }
  }

  async onMediaUpload(type: number) {
    if (type === 0) {
      (this.$refs.uploaderImage as UploadTo).uploadToOss().then((res: any) => {
        this.needSubmitImg = [...res];
        console.log('img urls result:', res);
      });
    } else if (type === 1) {
      (this.$refs.uploaderVideo as UploadTo).uploadToOss().then((res: any) => {
        this.video = [...res];
        console.log('video url result:', res);
      });
    }
  }

  handleClickSubmit(type: string) {
    let res: any = ''; // 表单返回检查消息
    if (type === 'cache') {
      this.submitData(type);
    } else if (type === 'submit') {
      // 检查表单

      checkForm.remove();
      checkForm.add(this.needSubmitImg, 'checkImg', '图片不能少于三张！');
      checkForm.add(this.name, 'checkName', '请填入作品名称！');
      checkForm.add(this.intro, 'checkIntro', '请填入作品简介！');
      checkForm.add(this.materials, 'checkMaterials', '请填入作品材料！');
      checkForm.add(this.size, 'checkSize', '请填入作品大小');
      if (this.radio === '1') {
        checkForm.add(this.price, 'checkPrice', '请输入正整数价格！');
      }
      res = checkForm.start();
      if (res) {
        return Toast(res);
      } else {
        this.submitData(type);
      }
    }
  }
  videoUrl(url: any) {
    this.video = url;
  }
  imgUrl(url: any) {
    this.needSubmitImg = url;
  }
  async submitData(type: string) {
    const data = {
      id: this.detailData.id,
      pictures:
        (this.needSubmitImg.length && '|' + this.needSubmitImg.join('|')) || '',
      videos: (this.video.length && '|' + this.video.join('|')) || '',
      title: this.name,
      introduction: this.intro,
      material: this.materials,
      workSize: this.size,
      ifSell: Number(this.radio),
      price: this.price,
    };
    // console.log('提交数据', data);
    // console.log('对比数据', this.tempData);
    const val = JSON.stringify(data) === JSON.stringify(this.tempData);
    let ret: any = '';
    if (type === 'cache') {
      // console.log('对比结果', val);
      if (val) {
        return Toast('没有修改内容，无需保存！');
      }
      ret = await saveData(data);
    } else {
      ret = await updated(data);
    }

    if (ret.code === 200) {
      if (type === 'cache') {
        Toast('保存成功');
        setTimeout(() => {
          this.$router.go(0);
        }, 500);
        return;
      }
      Toast('上传成功');
      setTimeout(() => {
        this.$router.go(0);
      }, 500);
    } else {
      Toast(ret.msg);
    }
  }
  // 预设值已有数据
  __presetData() {
    this.name = this.detailData.title;
    this.intro = this.detailData.introduction;
    this.materials = this.detailData.material;
    this.size = this.detailData.workSize;
    this.radio = String(this.detailData.ifSell);
    this.price = this.detailData.price;
    this.needSubmitImg = this.detailData.pictures;
    this.video = this.detailData.videos;
    // 设置图片
    this.presetImg =
      (this.detailData.pictures.length &&
        this.detailData.pictures.map((item: any) => {
          return {
            path: item,
            cover: item,
          };
        })) ||
      [];
    this.presetVideo =
      (this.detailData.videos &&
        this.detailData.videos.length &&
        this.detailData.videos.map((item: any) => {
          return {
            path: item,
            cover: `${item}?x-oss-process=video/snapshot,t_7000,f_jpg,w_800,h_600,m_fast`,
          };
        })) ||
      [];
  }
}
